// @ts-check
/** @type {import('../generated/clientHelpers').StrictTypedTypePolicies["Product"]} */
const productTypePolicies = {
  keyFields: ['productId'],
  fields: {
    // Make sure that all image sizes are available on the cache.
    bottleImage: { merge: true },
    files: { merge: true },
  },
};

export default productTypePolicies;
